import "./index.scss";

import KeyboardArrowDownIcon from "@mui/icons-material/KeyboardArrowDown";
import { CircularProgress, FormControl, InputLabel, Select, SelectProps } from "@mui/material";
import React, { FC, memo } from "react";

export interface DropdownProps extends SelectProps {
  loading?: boolean;
  selectedOptions?: any;
  customRenderItem?: (item: any, index: number) => React.ReactNode;
  showLabel?: boolean;
  shrink?: boolean;
  fullWidth?: boolean;
  className?: string;
}

const MemberPersonalInfoStatusDropdownComponent: FC<DropdownProps> = (props) => {
  const {
    loading = false,
    label = "",
    multiple,
    selectedOptions,
    customRenderItem,
    showLabel = true,
    shrink = true,
    fullWidth,
    ...restProps
  } = props;

  return (
    <FormControl fullWidth={fullWidth}>
      <Select
        sx={{ width: 235 }}
        IconComponent={(props) =>
          loading ? (
            <CircularProgress disableShrink color="success" size={20} {...props} />
          ) : (
            <KeyboardArrowDownIcon className="arrow-icon-member-details-info-status-dropdown" />
          )
        }
        {...restProps}
      />
    </FormControl>
  );
};

const MemberPersonalInfoStatusDropdown = memo(MemberPersonalInfoStatusDropdownComponent);
export default MemberPersonalInfoStatusDropdown;
